import useDispatcher from './useDispatcher';
import { AT } from '../actions/actionTypes';
import Logger from '../libs/logger'; import { LogArea } from '../libs/logger/const';

export const useRightPanel = () => {
  const { doAction } = useDispatcher();

  const setDialog = (dialogId = '') => {
    Logger.info(['setDialog', dialogId], LogArea.Redux); 
    doAction<string>(AT.DIALOG_ACTIVE_CHANGED, dialogId);
  };

  return {
    setDialog
  };
};

export default useRightPanel;
